import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { useState } from "react";
import { AuthState } from "context/AuthContext";
const DefaultLayout = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const { user } = AuthState();

	return (
		<div style={{ width: "100%" }}>
			<Navbar setDrawerOpen={setDrawerOpen} drawerOpen={drawerOpen} />
			<Box height={60} />

			{user && <Outlet />}
		</div>
	);
};

export default DefaultLayout;
